import { createEvent } from './createEvent'

type DashboardPageViewedProperties = {
  fid: string
  siteName: string
}

export const dashboardPageViewed = createEvent<DashboardPageViewedProperties>(
  'Dashboard Page Viewed',
)

type ReviewAnomaliesClickedProperties = {
  fid: string
}

export const reviewAnomaliesClicked =
  createEvent<ReviewAnomaliesClickedProperties>('Review Anomalies Clicked')

type AnomalyStateChangedProperties = {
  fid: string
  anomalyId: string
  // the state we are changing to
  state: string
  // the state we are changing from
  previousState: string
  // how long since the start of the anomaly
  // this is a proxy since we don't appear to have the creation time
  secondsToChange: number
}

export const anomalyStateChanged = createEvent<AnomalyStateChangedProperties>(
  'Anomaly State Changed',
)
